
// 红色感叹号
// <Warning/>

// 红色字
// <Text_R></Text_R>

// 红色感叹号加文字加背景红
// <Tab_Warning_Text_R></Tab_Warning_Text_R>

// 文字加背景蓝
// <Tab_Text_P></Tab_Text_P>

function reMate(resData) {
  // <Warning/> 正则
  let reg_wraning = /\$\{(.+?)\}/
  let reg_wraning_g = /<Warning[^>]*>/g

  // <Text_R/><Text_R> 正则
  let reg_r = /<Text_R[^>]*>(.+?)<\/Text_R>/
  let reg_r_g = /<Text_R[^>]*>(.+?)<\/Text_R>/g

  // <Tab_Warning_Text_R/><Tab_Warning_Text_R> 正则
  let reg_t_r = /<Tab_Warning_Text_R[^>]*>(.+?)<\/Tab_Warning_Text_R>/
  let reg_t_r_g = /<Tab_Warning_Text_R[^>]*>(.+?)<\/Tab_Warning_Text_R>/g

  // <Tab_Text_P/><Tab_Text_P> 正则
  let reg_t_p = /<Tab_Text_P[^>]*>(.+?)<\/Tab_Text_P>/
  let reg_t_p_g = /<Tab_Text_P[^>]*>(.+?)<\/Tab_Text_P>/g

  // <Text_Com_R/><Text_Com_R> 正则
  let reg_com_r = /<Text_Com_R[^>]*>(.+?)<\/Text_Com_R>/
  let reg_com_r_g = /<Text_Com_R[^>]*>(.+?)<\/Text_Com_R>/g

  // <Text_Com_B/><Text_Com_B> 正则
  let reg_com_b = /<Text_Com_B[^>]*>(.+?)<\/Text_Com_B>/
  let reg_com_b_g = /<Text_Com_B[^>]*>(.+?)<\/Text_Com_B>/g


  // let ImageIcon = '../assets'
  let ImageIcon = 'https://ql-data-prd.oss-cn-beijing.aliyuncs.com/WeChat/QL/img/image/report_icon_notice_d@2x.png'
  let newData = '';
  if(!resData){
    return
  }
  for(let i = 0;i < resData.length;i++){
    if(resData[i].match(reg_wraning_g)){
      newData += `<img class="reIcon" src="${ImageIcon}" alt=""/>`
    }else if(resData[i].match(reg_r_g)){
      newData += `<span class="colorFF7186">${resData[i].match(reg_r)[1]}</span>`
    }else if(resData[i].match(reg_com_r_g)){
		newData += `<span class="colorFF7186">${resData[i].match(reg_com_r)[1]}</span>`
	}else if(resData[i].match(reg_com_b_g)){
		newData += `<span class="color4A7CE8">${resData[i].match(reg_com_b)[1]}</span>`
	}else if(resData[i].match(reg_t_r_g)){
      newData += `
      <div class="bot_adv_tag">
        <img class="tanhaoIcon" src="${ImageIcon}"/>
        <span>${resData[i].match(reg_t_r)[1]}</span>
      </div>
    `
    }else if(resData[i].match(reg_t_p_g)){
      newData += `<span class="bot_adv_tag2 ml5 mr5">${resData[i].match(reg_t_p)[1]}</span>`
    }else{
      newData += `<span>${resData[i]}</span>`
    }
  }
  return newData;
}


// 傻逼后端不给改，前端需要单写个没有waring的正则
function reMate2(resData) {
  // <Warning/> 正则
  let reg_wraning = /\$\{(.+?)\}/
  let reg_wraning_g = /<Warning[^>]*>/g

  // <Text_R/><Text_R> 正则
  let reg_r = /<Text_R[^>]*>(.+?)<\/Text_R>/
  let reg_r_g = /<Text_R[^>]*>(.+?)<\/Text_R>/g

  // <Tab_Warning_Text_R/><Tab_Warning_Text_R> 正则
  let reg_t_r = /<Tab_Warning_Text_R[^>]*>(.+?)<\/Tab_Warning_Text_R>/
  let reg_t_r_g = /<Tab_Warning_Text_R[^>]*>(.+?)<\/Tab_Warning_Text_R>/g

  // <Tab_Text_P/><Tab_Text_P> 正则
  let reg_t_p = /<Tab_Text_P[^>]*>(.+?)<\/Tab_Text_P>/
  let reg_t_p_g = /<Tab_Text_P[^>]*>(.+?)<\/Tab_Text_P>/g


  // let ImageIcon = '../assets'
  let ImageIcon = 'https://ql-data-prd.oss-cn-beijing.aliyuncs.com/WeChat/QL/img/image/report_icon_notice_d@2x.png'
  let newData = '';
  if(!resData){
    return
  }
  for(let i = 0;i < resData.length;i++){
    if(resData[i].match(reg_wraning_g)){
      // newData += `<img class="reIcon" src="${ImageIcon}" alt=""/>`
    }else if(resData[i].match(reg_r_g)){
      newData += `<span class="colorFF7186">${resData[i].match(reg_r)[1]}</span>`
    }else if(resData[i].match(reg_t_r_g)){
      newData += `
      <div class="bot_adv_tag">
        <img class="tanhaoIcon" src="${ImageIcon}"/>
        <span>${resData[i].match(reg_t_r)[1]}</span>
      </div>
    `
    }else if(resData[i].match(reg_t_p_g)){
      newData += `<span class="bot_adv_tag2 ml5 mr5">${resData[i].match(reg_t_p)[1]}</span>`
    }else{
      newData += `<span>${resData[i]}</span>`
    }
  }
  return newData;
}

// 新增
function reMateNew(resData) {
	// <Warning/> 正则
	let reg_wraning = /\$\{(.+?)\}/
	let reg_wraning_g = /<Warning[^>]*>/g
  
	// <Text_R/><Text_R> 正则
	let reg_r = /<Text_R[^>]*>(.+?)<\/Text_R>/
	let reg_r_g = /<Text_R[^>]*>(.+?)<\/Text_R>/g

	// <Text_G/><Text_G> 正则
	let reg_green = /<Text_G[^>]*>(.+?)<\/Text_G>/
	let reg_green_g = /<Text_G[^>]*>(.+?)<\/Text_G>/g
  
	// <Tab_Warning_Text_R/><Tab_Warning_Text_R> 正则
	let reg_t_r = /<Tab_Warning_Text_R[^>]*>(.+?)<\/Tab_Warning_Text_R>/
	let reg_t_r_g = /<Tab_Warning_Text_R[^>]*>(.+?)<\/Tab_Warning_Text_R>/g
  
	// <Tab_Text_P/><Tab_Text_P> 正则
	let reg_t_p = /<Tab_Text_P[^>]*>(.+?)<\/Tab_Text_P>/
	let reg_t_p_g = /<Tab_Text_P[^>]*>(.+?)<\/Tab_Text_P>/g

	// <Text_Com_R/><Text_Com_R> 正则
	let reg_com_r = /<Text_Com_R[^>]*>(.+?)<\/Text_Com_R>/
	let reg_com_r_g = /<Text_Com_R[^>]*>(.+?)<\/Text_Com_R>/g
  
	// <Text_Com_B/><Text_Com_B> 正则
	let reg_com_b = /<Text_Com_B[^>]*>(.+?)<\/Text_Com_B>/
	let reg_com_b_g = /<Text_Com_B[^>]*>(.+?)<\/Text_Com_B>/g
  
  
	// let ImageIcon = '../assets'
	let ImageIcon = 'https://ql-data-prd.oss-cn-beijing.aliyuncs.com/WeChat/QL/img/image/report_icon_notice_d@2x.png'
	let newData = '<div class="richContentStyle">';
	if(!resData){
	  return
	}
	for(let i = 0;i < resData.length;i++){
	  if(resData[i].match(reg_wraning_g)){
		newData += `<img class="reIcon" src="${ImageIcon}" alt=""/>`
	  }else if(resData[i].match(reg_r_g)){
		newData += `<div class="richTextStyleRed">${resData[i].match(reg_r)[1]}</div>`
	  }else if(resData[i].match(reg_green_g)){
		newData += `<div class="richTextStyleGreen">${resData[i].match(reg_green)[1]}</div>`
	  }else if(resData[i].match(reg_com_r_g)){
		newData += `<div class="richTextStyleRed">${resData[i].match(reg_com_r)[1]}</div>`
	  }else if(resData[i].match(reg_com_b_g)){
		newData += `<div class="richTextStyleGreen">${resData[i].match(reg_com_b)[1]}</div>`
	  }else if(resData[i].match(reg_t_r_g)){
		newData += `
		<div class="bot_adv_tag">
		  <img class="tanhaoIcon" src="${ImageIcon}"/>
		  <span>${resData[i].match(reg_t_r)[1]}</span>
		</div>
	  `
	  }else if(resData[i].match(reg_t_p_g)){
		newData += `<span class="bot_adv_tag2 ml5 mr5">${resData[i].match(reg_t_p)[1]}</span>`
	  }else{
		newData += `<div class="richTextStyleNormal">${resData[i]}</div>`
	  }
	}
	newData += `</div>`
	return newData;
  }

  // 新增
function reMateNewNew(resData) {
	// <Warning/> 正则
	let reg_wraning = /\$\{(.+?)\}/
	let reg_wraning_g = /<Warning[^>]*>/g
  
	// <Text_R/><Text_R> 正则
	let reg_r = /<Text_R[^>]*>(.+?)<\/Text_R>/
	let reg_r_g = /<Text_R[^>]*>(.+?)<\/Text_R>/g

	// <Text_G/><Text_G> 正则
	let reg_green = /<Text_G[^>]*>(.+?)<\/Text_G>/
	let reg_green_g = /<Text_G[^>]*>(.+?)<\/Text_G>/g
  
	// <Tab_Warning_Text_R/><Tab_Warning_Text_R> 正则
	let reg_t_r = /<Tab_Warning_Text_R[^>]*>(.+?)<\/Tab_Warning_Text_R>/
	let reg_t_r_g = /<Tab_Warning_Text_R[^>]*>(.+?)<\/Tab_Warning_Text_R>/g
  
	// <Tab_Text_P/><Tab_Text_P> 正则
	let reg_t_p = /<Tab_Text_P[^>]*>(.+?)<\/Tab_Text_P>/
	let reg_t_p_g = /<Tab_Text_P[^>]*>(.+?)<\/Tab_Text_P>/g

	// <Text_R/><Text_R> 正则
	let reg_com_b = /<Text_Com_B[^>]*>(.+?)<\/Text_Com_B>/
	let reg_com_b_g = /<Text_Com_B[^>]*>(.+?)<\/Text_Com_B>/g
  
  
	// let ImageIcon = '../assets'
	let ImageIcon = 'https://ql-data-prd.oss-cn-beijing.aliyuncs.com/WeChat/QL/img/image/report_icon_notice_d@2x.png'
	let newData = '<div class="richContentStyleTip">';
	if(!resData){
	  return
	}
	for(let i = 0;i < resData.length;i++){
	  if(resData[i].match(reg_wraning_g)){
		newData += `<img class="reIcon" src="${ImageIcon}" alt=""/>`
	  }else if(resData[i].match(reg_r_g)){
		newData += `<div class="richTextStyleTipRed">${resData[i].match(reg_r)[1]}</div>`
	  }else if(resData[i].match(reg_com_b_g)){
		newData += `<div class="richTextStyleTipRed">${resData[i].match(reg_com_b)[1]}</div>`
	  }else if(resData[i].match(reg_green_g)){
		newData += `<div class="richTextStyleTipGreen">${resData[i].match(reg_green)[1]}</div>`
	  }else if(resData[i].match(reg_t_r_g)){
		newData += `
		<div class="bot_adv_tag">
		  <img class="tanhaoIcon" src="${ImageIcon}"/>
		  <span>${resData[i].match(reg_t_r)[1]}</span>
		</div>
	  `
	  }else if(resData[i].match(reg_t_p_g)){
		newData += `<span class="bot_adv_tag2 ml5 mr5">${resData[i].match(reg_t_p)[1]}</span>`
	  }else{
		newData += `<div class="richTextStyleTipNormal">${resData[i]}</div>`
	  }
	}
	newData += `</div>`
	return newData;
  }



export default {
  reMate,
  reMate2,
  reMateNew,
  reMateNewNew
}